import type { ValueOf } from './util/typeUtils';

export const SYSTEM_VARIABLE_TYPES = {
    BUCKETS: 'BUCKETS',
    SYSTEM_MAILS: 'SYSTEM_MAILS',
} as const;

export const EXTERNAL_SYSTEM_MAIL_TYPES = {
    system_applicant_advertisement_consent: 'system_applicant_advertisement_consent',
    system_applicant_advertisement_consent_with_info: 'system_applicant_advertisement_consent_with_info',
    system_applicant_co_verification: 'system_applicant_co_verification',
    // TODO: KC-5575 - this seems to be an old mail type which is not used anymore?
    system_applicant_confirmation: 'system_applicant_confirmation',
    system_applicant_data_protection_agreement_requested: 'system_applicant_data_protection_agreement_requested',
    system_applicant_documents_demanded: 'system_applicant_documents_demanded',
    system_applicant_documents_demanded_reminded: 'system_applicant_documents_demanded_reminded',
    system_applicant_info: 'system_applicant_info',
    system_applicant_verification: 'system_applicant_verification',
    system_loan_request_customer_cancel_reason_financing_request_expired:
        'system_loan_request_customer_cancel_reason_financing_request_expired',
    system_loan_request_customer_cancel_reason_not_reached: 'system_loan_request_customer_cancel_reason_not_reached',
    system_loan_request_data_deletion_cancel_reason: 'system_loan_request_data_deletion_cancel_reason',
    system_loan_request_mediator_document_review_cancel_reason:
        'system_loan_request_mediator_document_review_cancel_reason',
    system_loan_request_mediator_financial_cancel_reason: 'system_loan_request_mediator_financial_cancel_reason',
    system_loan_request_mediator_personal_cancel_reason: 'system_loan_request_mediator_personal_cancel_reason',
    system_loan_request_mediator_professional_cancel_reason: 'system_loan_request_mediator_professional_cancel_reason',
} as const;

export type EXTERNAL_SYSTEM_MAIL_TYPE = ValueOf<typeof EXTERNAL_SYSTEM_MAIL_TYPES>;

export const INTERNAL_SYSTEM_MAIL_TYPES = {
    system_user_2fa_resetted: 'system_user_2fa_resetted',
    system_user_password_resetted: 'system_user_password_resetted',
    system_user_registered: 'system_user_registered',
} as const;

export type INTERNAL_SYSTEM_MAIL_TYPE = ValueOf<typeof INTERNAL_SYSTEM_MAIL_TYPES>;

export const SYSTEM_MAIL_TYPES = {
    ...EXTERNAL_SYSTEM_MAIL_TYPES,
    ...INTERNAL_SYSTEM_MAIL_TYPES,
} as const;

export type SYSTEM_MAIL_TYPE = ValueOf<typeof SYSTEM_MAIL_TYPES>;

export const SYSTEM_BUCKET_DISTRIBUTION = {
    MANUAL: 'MANUAL',
    ROUND_ROBIN: 'ROUND_ROBIN',
    ROUND_ROBIN_LIMITED: 'ROUND_ROBIN_LIMITED',
} as const;

export type SYSTEM_BUCKET_DISTRIBUTION_TYPE = ValueOf<typeof SYSTEM_BUCKET_DISTRIBUTION>;
